<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="6" lg="4">
            <v-card class="elevation-12 ">
              <v-toolbar color="indigo" dark flat>
                <v-toolbar-title>{{ $ml.get("loginTitle") }}</v-toolbar-title>
              </v-toolbar>
              <v-form ref="form" v-model="valid" :lazy-validation="true">
                <v-card-text>
                  <v-text-field
                    :label="$ml.get('formEmailLabel')"
                    name="email"
                    prepend-icon="mdi-account"
                    placeholder=" "
                    type="email"
                    v-model="email"
                    :rules="emailRules"
                  />

                  <v-text-field
                    id="password"
                    :label="$ml.get('formPassLabel')"
                    name="password"
                    prepend-icon="mdi-lock"
                    placeholder=" "
                    type="password"
                    v-model="password"
                    :rules="passwordRules"
                  />
                </v-card-text>
                <v-card-actions>
                  <router-link class="mr-1" to="/forgot-password">{{
                    $ml.get("loginForgotLink")
                  }}</router-link>
                  <v-spacer />
                  <v-btn
                    type="submit"
                    color="indigo"
                    style="color:white "
                    :loading="loading"
                    @submit.prevent="onSubmit"
                    @click.prevent="onSubmit"
                    :disabled="!valid || loading"
                    >{{ $ml.get("loginButton") }}
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import _ from "lodash";
import EventBus from "../utils/event-bus";

export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      valid: false,
      emailRules: [
        v => !!v || this.$ml.get("formRuleRequired"),
        v => /.+@.+\..+/.test(v) || this.$ml.get("formRuleEmailErr")
      ],
      passwordRules: [v => !!v || this.$ml.get("formRuleRequired")]
    };
  },
  computed: {
    loading() {
      return false;
    }
  },
  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        const credentials = {
          email: this.email,
          password: this.password
        };
        this.$auth
          .login(credentials)
          .then(async () => {
            let currentUser = await this.$store.dispatch("user/me")
            console.log(currentUser)
            if (currentUser) {
              this.$ml.change(currentUser.language);
              this.$cookies.set('lang', currentUser.language);
            }
          })
          .then(() => this.$store.dispatch("organization/loadMyOrgs"))
          .then(() => this.$store.dispatch("organization/list"))
          .then(() => this.$router.push("/terminals"))
          .catch(error => {
            const message = _.get(error, "response.data.detail");
            if (message) {
              this.$message.error(message);
            }
          });
        EventBus.$on("user:logout", () => {
          this.$store.dispatch("organization/clearState");
        });
      }
    }
  }
};
</script>

<style scoped></style>
